import { useEffect, useState, useRef } from 'react';
import { EditCell } from './styles';

const getInitValue = (value, type) => (type === 'number' ? (isNaN(value) ? '' : value) : value);

// Create an editable cell renderer
const EditableCell = ({
  value: initialValue,
  row,
  column,
  updateCellData, // This is a custom function that we supplied to our table instance
  editFieldProps,
  type,
  isValid,
  isDisabled,
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);
  let textAreaRef = useRef(null);

  const onChange = (e) => {
    const val = e.target.value;
    if (isValid && !isValid(val)) {
      setValue('');
      return;
    }
    setValue(val);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateCellData(row?.index, column?.id, value);
  };

  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    // adjust height of the textarea
    if (!!textAreaRef) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px';
    }
  });

  let inputProps = editFieldProps ?? { invalidProp: null };

  return (
    <EditCell
      {...inputProps[column?.id]}
      value={value}
      rows={1}
      type={type}
      onChange={onChange}
      onBlur={onBlur}
      ref={textAreaRef}
      disabled={isDisabled}
    />
  );
};

export default EditableCell;
